import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from "react-helmet";
import '../../styles/Fonts.css'; // Import Hero specific CSS for Font
import '../../styles/Homepage.css'; // Import modern Homepage CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

// Dynamic Images for the Hero Section 
import defaultBg from '../../assets/new/track.webp';
import one from '../../assets/new/track.webp';
import two from '../../assets/new/forwarding2.webp';
import three from '../../assets/new/project.webp';
import four from '../../assets/AboutBG.webp';


// Import homepage section components
import CargoManagement from './CargoManagement';
import OurServices from './OurServices';
import WhyChooseUs from './WhyChooseUs';
import GalleryPreview from './GalleryPreview';
import Contact from './Contact'; 
import Networks from './Networks'; 

const Hero = () => {
  // State for background image and active icon
  const [bgImage, setBgImage] = useState(defaultBg);
  const [imageIndex, setImageIndex] = useState(0);


  // Memoize the images array to prevent unnecessary re-renders
  const images = useMemo(() => [
    { img: one, icon: 'track' },
    { img: two, icon: 'transport' },
    { img: three, icon: 'forwarding' },
    { img: four, icon: 'brokerage' },
  ], []);

  // Function to update the background image and active icon
  const changeBackground = (image) => {
    if (window.innerWidth > 992) {  // Only change background on screens larger than 992px
      setBgImage(image);
    }
  };

  // Automatically set the default background and active icon on component mount
  useEffect(() => {
    changeBackground(images[0].img);

    // Set an interval to automatically change the background every 5 seconds on large screens
    const interval = window.innerWidth > 992 ? setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000) : null; // Only set the interval if screen width is greater than 992px

    return () => clearInterval(interval); // Clear the interval on component unmount
  }, [images]);

  // Effect to update the background image when the imageIndex changes
  useEffect(() => {
    const { img } = images[imageIndex];
    changeBackground(img);
  }, [imageIndex, images]); // Add 'images' as a dependency

  return (
    <>
      <Helmet>
        <title>RCS Logistics Philippines - Moving You Forward</title>
        <meta name="description" content="Partner with RCS Logistics Philippines to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta name="keywords" content="logistics, transportation, RCS Logistics, Philippines, forwarding, brokerage, sea land service, freight forwarding, international shipping, supply chain management, cargo handling, customs brokerage, project cargo, warehousing, import export, air freight, ocean freight, domestic transportation, logistics services" />
          <meta property="og:url" content="https://rcslogisticsph.com/" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content="RCS Logistics Philippines - Moving You Forward" />
          <meta property="twitter:description" content="Partner with the best to ensure your transportation is in expert hands, guaranteeing smooth deliveries and exceptional service." />
          <meta property="twitter:image" content="https://rcslogisticsph.com/path_to_your_image.png" />
        </Helmet>
    
    <div>
      {/* Hero Section with Dynamic Background */}
      <section 
        className="homepage-hero-section" 
        style={{ 
          backgroundImage: `url(${bgImage})`
        }}
      >
        <div className="homepage-hero-overlay"></div>
        <div className="container hero-content">
          <div className="row">
            <div className="col-lg-10 col-xl-9">
              <div className="text-start">
                <button className="hero-badge" disabled>
                  WE HELP YOU MOVE AHEAD
                </button>
                <h1 className="hero-main-title text-white">
                  RCS Logistics Philippines
                </h1>
                <p className="hero-description text-white">
                  Partner with the best to ensure your transportation is in 
                  expert hands, guaranteeing smooth deliveries and exceptional service.
                </p>
                <div className="hero-actions">
                  <a href="/contactUs" className="btn-primary-hero">Get a Quote</a>
                  <a href="#services-preview" className="btn-secondary-hero">Learn More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <CargoManagement />

      <OurServices />

      <WhyChooseUs />

      <GalleryPreview />

      <Contact />
      <Networks />
    </div>
    </>
  );
};

export default Hero;
